import React from 'react';

import { sortBy } from 'lodash';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import type { Project } from '~/services/ContractingService';

import { timelineHealth } from '~/utils/projectTasks';

import HealthDot from './HealthDot';
import { TASK_STATUS_LABELS, formatProjectDate } from './projectManagementModel';

interface Props {
  project: Project;
}

export default function TaskListTable({ project }: Props) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table aria-label="Project tasks" size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Start date</TableCell>
            <TableCell>End date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="center">Timeline health</TableCell>
            <TableCell>Assignees</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortBy(project.tasks, 'startDate').map((task) => {
            const timeline = timelineHealth(task);
            return (
              <TableRow key={task.id} hover>
                <TableCell>{task.name}</TableCell>
                <TableCell>{formatProjectDate(task.startDate)}</TableCell>
                <TableCell>{formatProjectDate(task.endDate)}</TableCell>
                <TableCell>{TASK_STATUS_LABELS[task.status]}</TableCell>
                <TableCell align="center">{timeline && <HealthDot result={timeline} />}</TableCell>
                <TableCell>
                  {task.assignees.length ? (
                    task.assignees.map((assignee) => assignee.name).join(', ')
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Unassigned
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
